import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  ArrowUpRight,
  ChevronLeft,
  ChevronRight,
  Users,
  HeartHandshake,
  Globe2,
  Sparkles,
} from "lucide-react";
import AutoImageSlider from "../components/AutoImageSlider";

// const HERO_IMG =
//   "https://images.unsplash.com/photo-1754531976828-69e42ce4e0d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxpbmRpYW4lMjBwcm9mZXNzaW9uYWxzJTIwbWVldGluZ3xlbnwwfHx8fDE3NzYzODA4NzN8MA&ixlib=rb-4.1.0&q=85";
const ABOUT_IMG = "/citypalace.jpg";
const TESTIMONIALS = [
  {
    q: "This forum keeps our professional circle connected, informed, and ready to support one another.",
    a: "Prakash Ji Kothari",
    r: "Council member, Oswal Sabha",
  },
  {
    q: "We have built a space where trust, service, and meaningful introductions actually happen.",
    a: "Pramila Ji",
    r: "Community voice, Udaipur",
  },
  {
    q: "The network here is practical, warm, and genuinely useful for members across generations.",
    a: "Sanjay Dungarwal",
    r: "Professional network member",
  },
  {
    q: "It feels good to be part of a forum that balances tradition with active community engagement.",
    a: "Vijitha Mehta",
    r: "Forum supporter",
  },
  {
    q: "The members are proactive, and the council keeps the platform active with real initiatives.",
    a: "Arun Mandot",
    r: "Member, Udaipur chapter",
  },
  {
    q: "Service, mentoring, and connection all come together here in a very grounded way.",
    a: "Mahendra Mehta",
    r: "District Judge (Retd.)",
  },
  {
    q: "This is the kind of community people want to stay involved with for the long term.",
    a: "Hitesh Mandot",
    r: "Forum member",
  },
];
export default function Home() {
  const [galleryImages] = useState([]);
  const [testimonialIndex, setTestimonialIndex] = useState(0);

  useEffect(() => {
    if (!TESTIMONIALS.length) return undefined;
    const timer = setInterval(() => {
      setTestimonialIndex((current) => (current + 1) % TESTIMONIALS.length);
    }, 6500);
    return () => clearInterval(timer);
  }, []);

  const goToPrevTestimonial = () => {
    setTestimonialIndex((current) =>
      current === 0 ? TESTIMONIALS.length - 1 : current - 1,
    );
  };

  const goToNextTestimonial = () => {
    setTestimonialIndex((current) => (current + 1) % TESTIMONIALS.length);
  };

  return (
    <div data-testid="home-page">
      {/* TOP BANNER */}
      <div className="w-full overflow-hidden rounded-b-3xl bg-[#07115b]">
        <img
          src="/banner1.jpg"
          alt="OSPF Banner"
          className="block w-full h-auto object-contain object-center"
        />
      </div>
      {/* HERO SECTION WITH SCENERY & FROSTED GLASS */}
      <section className="py-10 sm:py-10 md:py-14 bg-cream">
        <div className="container-px grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-center w-full">
          <div className="max-w-xl order-1">
            <div className="inline-flex items-center rounded-full border border-orange-200 bg-gradient-to-r from-orange-50 via-white to-orange-50 px-4 py-2 shadow-[0_12px_30px_rgba(249,115,22,0.12)] mb-5 sm:mb-3">
              <span className="text-[10px] sm:text-xs font-bold tracking-[0.22em] uppercase text-orange-700">
                Oswal Sabha Professional Forum • Udaipur
              </span>
            </div>

            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-medium sm:font-light leading-[1.1] sm:leading-[1.02] tracking-tight text-gray-900">
              Turning{" "}
              <span className="italic text-orange-500 font-normal">expertise</span>
              <br />
              <span className="font-semibold">into welfare.</span>
            </h1>

            <div className="mt-8 sm:mt-5 flex flex-col sm:flex-row gap-3">
              <Link
                to="/member/login?mode=register"
                className="w-full sm:w-auto px-6 py-3 rounded-full bg-orange-600 text-white font-medium shadow hover:bg-orange-700 transition text-center"
              >
                Apply for Membership
              </Link>

              <Link
                to="/directory"
                className="w-full sm:w-auto px-6 py-3 rounded-full border border-gray-300 text-gray-700 hover:bg-gray-100 transition inline-flex items-center justify-center gap-2"
              >
                Browse Directory
                <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>

            <p className="mt-6 sm:mt-4 text-[15px] sm:text-base leading-[1.6] text-gray-600 max-w-lg font-normal">
              Connecting Oswal Jain professionals across Udaipur and beyond,
              creating opportunities for collaboration, growth, and community impact.
            </p>
          </div>

          <div className="relative order-2">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              {galleryImages.length > 0 ? (
                <AutoImageSlider
                  images={galleryImages}
                  alt="Udaipur City Palace and OSPF moments"
                  className="w-full h-64 sm:h-80 lg:h-[420px]"
                  imageClassName="object-center"
                />
              ) : (
                <div className="flex min-h-[16rem] sm:min-h-[20rem] lg:min-h-[420px] items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-8 text-center text-white/80">
                  <div>
                    <div className="text-sm uppercase tracking-[0.3em] text-white/50">
                      Gallery coming soon
                    </div>
                    <p className="mt-4 text-lg leading-relaxed">
                      Community photos and event highlights will appear here once they are added.
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="absolute -bottom-4 left-4 lg:-bottom-6 lg:-left-6 bg-white/90 backdrop-blur shadow-lg rounded-xl px-4 lg:px-5 py-2.5 lg:py-3 text-sm text-gray-700">
              Udaipur • Rajasthan
            </div>
          </div>
        </div>
      </section>
      {/* BANNER STRIP */}
      <section className="container-px -mt-10 md:-mt-12">
        <div className="rounded-3xl bg-white shadow-premium border border-black/5 p-6 md:p-10">
          <div className="mb-4 md:mb-5 flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
            <div>
              <div className="inline-flex items-center rounded-full bg-cream-deep px-3 py-1 text-xs font-medium text-brand-secondary">
                Community stories, events and service
              </div>
              <h2 className="mt-3 font-heading text-3xl md:text-5xl font-light text-ink leading-tight">
                A shared space for the moments that bring us together.
              </h2>
              <p className="mt-3 text-ink-soft max-w-3xl leading-relaxed">
                From gatherings and learning sessions to seva and celebrations,
                this banner keeps the spirit of the forum visible at a glance.
              </p>
            </div>
            <Link
              to="/events/new-event/register"
              className="btn-primary inline-flex justify-center shrink-0"
            >
              NEW EVENT Register here
            </Link>
          </div>
        </div>
      </section>

      {/* STATS BENTO */}
      <section className="container-px -mt-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {[
            { k: "10", v: "Welfare Activities done (2026)" },
            { k: "Udaipur", v: "City chapters" },
            { k: "2", v: "Years of service" },
          ].map((s, i) => (
            <div
              key={i}
              className="card-premium"
              data-testid={`stat-card-${i}`}
            >
              <div className="font-heading text-3xl md:text-4xl font-medium text-ink">
                {s.k}
              </div>
              <div className="text-sm text-ink-soft mt-2">{s.v}</div>
            </div>
          ))}
        </div>
      </section>

      {/* PILLARS */}
      <section className="section-py container-px">
        <div className="max-w-2xl">
          <div className="overline mb-5">What we do</div>
          <h2 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-ink leading-tight">
            Four pillars that power our community.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
          {[
            {
              icon: Users,
              title: " Knowledge for Community Growth",
              body: "To utilize the collective expertise, experience, and professional capabilities of our community for the advancement and welfare of both members and society at large.",
            },
            {
              icon: HeartHandshake,
              title: " Professional Excellence, Stronger Solutions",
              body: "To bring together professionals from diverse fields on a common platform to collaboratively develop practical, innovative, and sustainable solutions to complex challenges.",
            },
            {
              icon: Globe2,
              title: "Empowering the Next Generation",
              body: "To empower the younger generation through structured career guidance, mentorship, and continuous support, enabling them to achieve excellence and leadership in their chosen professions.",
            },
            {
              icon: Sparkles,
              title: "Networking & Professional Development",
              body: "To build a strong and dynamic professional network that promotes knowledge-sharing, continuous learning, mutual collaboration, leadership development, and the exchange of innovative ideas, while creating meaningful opportunities for the personal, professional, and social growth of members.",
            },
          ].map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={i}
                className="card-premium group"
                data-testid={`pillar-card-${i}`}
              >
                <div className="w-12 h-12 rounded-2xl bg-brand/10 text-brand flex items-center justify-center mb-6 group-hover:bg-brand group-hover:text-white transition-colors">
                  <Icon className="w-5 h-5" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-xl font-medium text-ink">
                  {p.title}
                </h3>
                <p className="mt-3 text-ink-soft leading-relaxed">{p.body}</p>
              </div>
            );
          })}
        </div>
      </section>

      {/* ABOUT SNIPPET */}
      <section className="py-16 md:py-24 container-px">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          <div className="order-2 lg:order-1">
            <div className="overline mb-5">About the forum</div>
            <h2 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-ink leading-tight">
              A Ancient legacy of
              <span className="italic text-brand"> professional kinship.</span>
            </h2>
            <p className="mt-8 text-ink-soft leading-relaxed">
              From its founding in 2025 by a handful of Udaipur-based
              professionals, the forum has grown into a global society of
              leaders — bound by lineage, united by values, and organised around
              welfare.
            </p>
            <Link
              to="/about"
              className="btn-secondary mt-8"
              data-testid="home-about-link"
            >
              Read our story <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
          <div className="order-1 lg:order-2 relative">
            <div className="rounded-3xl overflow-hidden shadow-premium">
              <img
                src={ABOUT_IMG}
                alt="Oswal Professional Networking Udaipur"
                className="w-full h-[440px] object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-16 md:py-28 container-px">
        <div className="max-w-2xl mb-12 md:mb-16">
          <div className="overline mb-5">Voices from the forum</div>
          <h2 className="font-heading text-4xl md:text-5xl font-light tracking-tight text-ink leading-tight">
            Member testimonials.
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_0.9fr] gap-6 md:gap-8 items-stretch">
          <div className="card-premium relative overflow-hidden">
            <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-orange-500 via-orange-300 to-transparent" />
            <div className="flex items-center justify-between gap-4">
              <button
                type="button"
                onClick={goToPrevTestimonial}
                className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white text-ink hover:bg-black/5 transition"
                aria-label="Previous testimonial"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>

              <div className="text-xs uppercase tracking-[0.28em] text-brand-secondary">
                Featured member note
              </div>

              <button
                type="button"
                onClick={goToNextTestimonial}
                className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-black/10 bg-white text-ink hover:bg-black/5 transition"
                aria-label="Next testimonial"
              >
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>

            <div className="mt-8 min-h-[240px] md:min-h-[260px] flex flex-col justify-between">
              <div>
                <svg
                  width="28"
                  height="20"
                  viewBox="0 0 28 20"
                  className="text-brand mb-6"
                >
                  <path
                    fill="currentColor"
                    d="M0 20V12c0-6.6 3.7-10.7 10-12l2 4c-3.3 1-5 3-5 6h5v10H0zm16 0V12c0-6.6 3.7-10.7 10-12l2 4c-3.3 1-5 3-5 6h5v10H16z"
                  />
                </svg>
                <blockquote className="font-heading text-2xl md:text-3xl leading-relaxed text-ink">
                  “{TESTIMONIALS[testimonialIndex].q}”
                </blockquote>
              </div>

              <figcaption className="mt-8 text-sm">
                <div className="font-semibold text-ink">
                  {TESTIMONIALS[testimonialIndex].a}
                </div>
                <div className="text-ink-muted mt-1">
                  {TESTIMONIALS[testimonialIndex].r}
                </div>
              </figcaption>
            </div>

            <div className="mt-8 flex items-center gap-2">
              {TESTIMONIALS.map((item, index) => (
                <button
                  key={item.a}
                  type="button"
                  onClick={() => setTestimonialIndex(index)}
                  className={`h-2.5 rounded-full transition-all ${
                    index === testimonialIndex
                      ? "w-8 bg-brand"
                      : "w-2.5 bg-black/15 hover:bg-black/30"
                  }`}
                  aria-label={`Show testimonial ${index + 1}`}
                />
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6">
            {TESTIMONIALS.slice(0, 2).map((t, i) => (
              <figure
                key={t.a}
                className="card-premium"
                data-testid={`testimonial-${i}`}
              >
                <blockquote className="font-heading text-xl leading-relaxed text-ink">
                  “{t.q}”
                </blockquote>
                <figcaption className="mt-6 text-sm">
                  <div className="font-medium text-ink">{t.a}</div>
                  <div className="text-ink-muted">{t.r}</div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="container-px pb-24">
        <div
          className="rounded-3xl bg-ink text-white p-10 md:p-16 relative overflow-hidden"
          data-testid="home-cta-banner"
        >
          <div className="relative z-10 max-w-xl">
            <div className="overline mb-4 text-brand-secondary">Join us</div>
            <h2 className="font-heading text-4xl md:text-5xl font-light tracking-tight">
              Bring your <span className="italic text-brand">expertise</span>.
              <br />
              Find your community.
            </h2>
            <Link
              to="/membership"
              className="btn-primary mt-8"
              data-testid="cta-join-btn"
            >
              Begin your application <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
